import React, { createContext, useContext, useState, useEffect } from 'react';
import { languages, userProgress } from '../data/mock';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(userProgress.currentLanguage);
  const [currentLevel, setCurrentLevel] = useState(userProgress.currentLevel);
  const [selectedWords, setSelectedWords] = useState([]);
  const [progress, setProgress] = useState(userProgress);

  const getLanguageInfo = (code) => {
    return languages.find(lang => lang.code === code) || languages[0];
  };

  const addSelectedWord = (word) => {
    setSelectedWords(prev => {
      if (prev.find(w => w.word === word.word)) {
        return prev.filter(w => w.word !== word.word);
      }
      return [...prev, { ...word, selected: true }];
    });
  };

  const updateProgress = (updates) => {
    setProgress(prev => ({ ...prev, ...updates }));
  };

  const value = {
    currentLanguage,
    setCurrentLanguage,
    currentLevel,
    setCurrentLevel,
    selectedWords,
    setSelectedWords,
    addSelectedWord,
    progress,
    updateProgress,
    getLanguageInfo
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};